module.exports = {"id":"209372","name":"Mustafa Saymak","rating":"73","photo":"./data/images/photos/1/209372.png","club":{"name":"PEC Zwolle","logo":"./data/images/clubs/PECZwolle.png"},"positions":["MOC","MC","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MustafaSaymak0.json
// module id = 3107
// module chunks = 0